import ImgNoRattacher from '@orientaction/Asset/Ressources/nonRattacher.png';
import { useHistory } from 'react-router-dom';
import { PageHeader, RedesignLayout, useSharedStyles } from '../../shared';
import RedesignImage from '../../shared/components/RedesignImage';
import locale from '../locale.json';
import { useNoAttachedResourcesStyles } from './index.styles';

const NoAttachedResources = () => {
  const classes = useNoAttachedResourcesStyles();
  const sharedClasses = useSharedStyles();
  const history = useHistory();

  return (
    <RedesignLayout footer={true} noPadding={true}>
      <div className={sharedClasses.pageShell}>
        <PageHeader
          breadcrumbs={[{ label: locale.home, href: '/main' }, { label: locale.pageTitle }]}
          title={locale.pageTitle}
          description={locale.pageDescription}
          titleVariant="primary"
        />
        <div className={classes.noAccessCard}>
          <RedesignImage
            src={ImgNoRattacher}
            className={classes.noAccessImage}
            alt={locale.pageTitle}
          />
          <p className={classes.noAccessTitle}>{locale.noAccessTitle}</p>
          <p className={classes.noAccessSubtitle}>{locale.noAccessSubtitle}</p>
          <p className={classes.noAccessText}>
            {locale.noAccessContact}{' '}
            <a
              href="https://www.orientaction-groupe.com/contact/"
              target="_blank"
              rel="noreferrer noopener">
              {locale.contactLink}
            </a>
          </p>
          <button
            type="button"
            className={classes.primaryButton}
            onClick={() => history.push('/main')}>
            {locale.back}
          </button>
        </div>
      </div>
    </RedesignLayout>
  );
};

export default NoAttachedResources;
